import { combineReducers } from 'redux';
import paymentMethodsReducer from './paymentMethodsReducer';
import setDefaultPaymentMethodReducer from './setDefaultPaymentMethodReducer';

export default combineReducers({
  paymentMethods: paymentMethodsReducer,
  setDefaultPaymentMethod: setDefaultPaymentMethodReducer,
});
